import React from "react";

const SvgCrime = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path
      fill="currentColor"
      d="M137.856 72.181l15.566-15.56 3.26 3.26-15.567 15.56zm11.094 34.189h22v4.61h-22zM104.9 46.38h4.61v22.01h-4.61zm-60.85 59.99h22.01v4.61H44.05zm14.264-46.504l3.26-3.26L77.137 72.17l-3.26 3.26zM157.05 166.68l-2.3-18.85a1.73 1.73 0 00-1.72-1.51h-13.48l-4.06-57.81H78.36l-4.06 57.81H62a1.73 1.73 0 00-1.72 1.51L58 166.68a1.72 1.72 0 001.71 1.94h95.68a1.71 1.71 0 001.29-.58 1.7 1.7 0 00.37-1.36zm-95.43-1.52l1.88-15.39h88l1.89 15.39z"
    />
  </svg>
);

export default SvgCrime;